import { h } from 'preact'
import { ProductAreaType } from '../../product-areas/ProductAreaSelect'

interface Props {
  productAreas: Array<ProductAreaType>,
  onCallback: (status: string | null) => void,
  selected: null | string
}

const ProductAreaFilter = ({ productAreas, selected, onCallback }: Props) => {
  return (
    <div className='box__content box__pad ideation-filters'>
      <h3 className='widget-title'>Filter by product areas</h3>
      <ul className='ideation-filters__product-area'>
        <li className={selected === null ? 'selected' : ''} onClick={() => onCallback(null)}>
          <div className='vertical-line' />
          <span>All product areas</span>
        </li>
        {
          productAreas.map(({ name }) => (

            <li className={selected === name ? 'selected' : ''} onClick={() => onCallback(name)}>
              <div className='vertical-line' />
              <span>{ name }</span>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default ProductAreaFilter
